import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, Observer, Subscription } from 'rxjs';

declare var $: any;

export const CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckBoxModComponent),
  multi: true
};

@Component({
    selector: '[singleCheckBoxModInput]',
  templateUrl: 'checkbox.component.html',
  providers: [CHECKBOX_VALUE_ACCESSOR]
})
export class CheckBoxModComponent implements ControlValueAccessor, OnInit {
  @Input() labelInput: string;
  @Input() idInput: string;
  @Input() submitPending: boolean;
  @Input() objectReference: any;
  @Input() mandatory: boolean;
  @Input() showLabel: boolean = true;
  @Input() labelChecked: string;
  @Input() labelNotChecked: string;
  @Input() labelSemibold: boolean;
  @Input() layout: 'normal' | 'no-label' | 'label-next' = "normal";
  @Output() onReturn = new EventEmitter();

  _value: boolean;
  onTouchedCallback: () => void = () => { };
  onChangeCallback: (_: any) => void = () => { };
  randomValueString: string;
  internalObject: any;
  public enableObservable: Observable<boolean>;
  subscription: Subscription = null;
  enableObserver: Observer<boolean>;

  constructor(private httpService: HttpClient) {
    this.randomValueString = '' + Math.round(Math.random() * 100000);
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable<boolean>(observer => {
      this.enableObserver = observer;
    if ( this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
  }

  ngOnChanges(): void {
    this.internalObject = this.objectReference ? JSON.parse(JSON.stringify(this.objectReference)) : false;
  }

  onChange() {
    this.onReturn.emit(this.internalObject);
  }

  valueToLabel(isChecked: boolean): string {
    let result: string;
    if (isChecked) {
      if (this.labelChecked) {
        result = this.labelChecked;
      }else {
        result = 'Si';
      }
    } else {
      if (this.labelNotChecked) {
        result = this.labelNotChecked;
      }else {
        result = 'No';
      }
    }
    return result;
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
}
